import React, { useEffect, useState } from "react";
import {fire} from "../firebase/config";
import { Link } from "react-router-dom";

function AdPage(props) {
  const [item, setItem] = useState({});
  const [owner, setOwner] = useState();
  useEffect(() => {
    fire
      .database()
      .ref("/ad/" + props.match.params.id)
      .once("value")
      .then((snapshot) => {
        setItem(snapshot.val());
        fire
          .database()
          .ref("/users/" + snapshot.val().ownerId)
          .once("value")
          .then((snapshot) => {
            setOwner(snapshot.val());
            console.log(item.ownerId);
          });
      });
      
      return () => {};
  }, []);
  return (
    <section class="shop">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="shop__line">
              <div class="shop__wrapper">
                <div class="shop__box">
                  <div class="shop-item d-flex">
                    <div class="shop__content">
                      <div class="shop__title">{item.name}</div>
                      <div class="shop__name">
                        <a href="#">{item.link}</a>
                      </div>
                      <div class="shop__date d-flex">
                        <div class="shop-date__when">
                          Добавлено: 2020-07-03 (ред. 2020-07-07)
                        </div>
                        <div class="shop-date__seems">
                          Просмотров: 24
                          <div class="shop-date-seems__eye">
                            <img src="/img/eye.png" alt="img" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="shop-item__img">
                      <img src={item.photo} alt="" />
                    </div>
                  </div>
                  <div class="shop-sb">
                    <div class="shop-sb__doxod">
                      Подписчики: <span>{item.followers}</span>
                      <div class="shop-sb-doxod__abs">
                        <img src="/img/human.png" alt="img" />
                      </div>
                    </div>
                    <div class="shop-sb__doxod">
                      Доход: <span>{item?.amount}</span>
                      <div class="shop-sb-doxod__abs">
                        <img src="/img/koshel.png" alt="img" />
                      </div>
                    </div>
                  </div>
                  <div class="shop__yn">
                    <div class="shop-yn__text">
                      Тематика:<span>{item.category}</span>
                    </div>
                    <div class="shop-yn__text">
                      Торг:<span>Нет</span>
                    </div>
                    <div class="shop-yn__subtitle">{item.description}</div>
                  </div>
                  <div class="shop__buy d-flex">
                    <div class="shop-buy__sum">{item.price}$</div>
                    <div class="shop-sum__btn">
                      <div class="shop-sum-click">
                        <a href="#">Купить</a>
                      </div>
                      <div class="shop-sum__text">
                        Все сделки безопасны и контролируются администрацией
                        сайта
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="shop__line">
              <div class="shop__int">
                <div class="shop-int__title">Интернет магазин Мелония</div>
                <div class="shop-int__items d-flex">
                  <div class="shop-int__item d-flex">
                    <div class="shop-int-sh">
                      <div class="shop-int__subtitle">Продавец</div>
                      <div class="shop-int-content__img">
                        <img src="/img/seller.png" alt="img" />
                      </div>
                    </div>
                    <div class="shop-int__content">
                      <div class="shop-int-content__text">
                        <div class="shop-int-content-text__was">
                          был 6 минут назад
                        </div>
  <div class="shop-int-content-text__name">{owner ? owner.name :"..."}</div>
                        <div class="shop-int-content-text__massage">
                          <Link to={`/message/${item.ownerId}`}>
                          НАПИСАТЬ СООБЩЕНИЕ
                          </Link>

                  
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="shop-int__item">
                    <div class="shop-int__reviews d-flex">
                      Отзывы:
                      <div class="shop-int-num d-flex">
                        <div class="shop-int-num_numbers1">+130</div>
                        <div class="shop-int-num_numbers2">2</div>
                        <div class="shop-int-num_numbers3">4</div>
                      </div>
                    </div>
                    <div class="shop-int__pbs">
                      Проведено безопасных сделок: <span>2</span>
                    </div>
                    <div class="shop-int-from">
                      На сайте: <span>2020-07-08</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="shop-disc">
              <div class="shop-disc__title">Обсуждение</div>
              <form action="#" class="shop-disck-form">
                <div class="shop-disc__text">
                  <input
                    type="text"
                    placeholder="Добавить первый комментарий"
                    class="shop-disctext"
                  />
                </div>
                <div class="shop-disk__btn">
                  <button>ОТПРАВИТЬ</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdPage;
